import React from "react";
import update from "immutability-helper";

class InputFormTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            editingData: props.data,
        };
        this.excludedNames = props.excludedNames ? props.excludedNames : [];
    }

    onChange = (e) => {
        if (this.props.onChange) {
            this.props.onChange(e);
            let editingData = update(this.state.editingData, { [e.target.name]: { $set: e.target.value } });
            this.setState({ editingData: editingData });
        } else {
            console.log("onChange:", e.target.name, e.target.value);
            let editingData = update(this.state.editingData, { [e.target.name]: { $set: e.target.value } });
            this.setState({ editingData: editingData });
        }
    };

    createTable = (data) => {
        let arr = [];
        for (let key in data) {
            if (!this.excludedNames.includes(key)) {
                arr.push(
                    <tr>
                        <td>{key}</td>
                        <td>
                            <input key={key} id={key} name={key} className="textM" type="text" value={this.state.editingData[key]} onChange={this.onChange} />
                        </td>
                    </tr>,
                );
            }
        }

        return (
            <div className="TWrap l-mtS" style={{ overflowY: "scroll" }}>
                <table className="table">
                    <thead>
                        <tr>
                            <th>パラメータ名</th>
                            <th>設定値</th>
                        </tr>
                    </thead>
                    <tbody>{arr}</tbody>
                </table>
            </div>
        );
    };

    /*
    createHeader = (data) => {
        let cols = [];
        for (let key in data) {
            cols.push(
                <th key={key}>
                {key}
                </th>
        );
        }

        return (
            <tr>
            {cols}
            </tr>
        );
    }

    createForms = (data) => {
        let cols = [];
        for (let key in data) {
            cols.push(
                <td key={`${key}`}>
                <input className="textM" type="text" name={key} value={this.state.editingData[key]} onChange={this.onChange}/>
            </td>);
        }

        return (
            <tr key="InputFormTable Form">
            {cols}
            </tr>
        );
    }
    */

    onClickOK = (e) => {
        this.props.onClickOK(this.state.editingData);
        this.setState({ editingData: {} });
        console.log("onClickOK:", this.state.editingData);
    };

    onClickCancel = (e) => {
        this.props.onClickCancel();
        this.setState({ editingData: {} });
    };

    render() {
        return (
            <div key="InputFormTable">
                {this.createTable(this.props.data)}
                <div className="l-row">
                    {this.props.onClickOK ? (
                        <button className="sBtn" onClick={this.onClickOK}>
                            OK
                        </button>
                    ) : null}

                    {this.props.onClickCancel ? (
                        <button className="sBtn l-mlS" onClick={this.onClickCancel}>
                            Cancel
                        </button>
                    ) : null}
                </div>
            </div>
        );
    }
}

export default InputFormTable;
